export const FAQS = [
  {
    question: "How long does the battery last on a single charge?",
    answer: "Our batteries are specifically designed for golf. Depending on the model, you can expect between 18 to 60 holes of play."
  },
  {
    question: "Are these scooters safe for the turf?",
    answer: "Absolutely. Our scooters feature high-flotation, low-pressure tires specifically engineered to distribute weight evenly."
  },
  {
    question: "Do I need any special tools to assemble it?",
    answer: "No. Most models arrive 95% assembled. You typically only need to attach the seat and handlebars with the included tool kit."
  },
  {
    question: "Can these handle hilly or uneven terrain?",
    answer: "Yes. All OUR MODELS feature high-torque motors and advanced suspension systems designed specifically for steep fairway hills."
  },
  {
    question: "What kind of maintenance is required?",
    answer: "Very little. We recommend checking tire pressure monthly and keeping the battery charged."
  },
  {
    question: "Is there a weight limit for the riders?",
    answer: "Our standard models are tested for riders up to 300 lbs (136 kg)."
  }
];